import { render, staticRenderFns } from "./AModulosCrear.vue?vue&type=template&id=02655ac0"
import script from "./AModulosCrear.vue?vue&type=script&lang=js"
export * from "./AModulosCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports